"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ingredients = void 0;
var React = require("react");
var state_1 = require("../compare/state");
var Ingredients = function () {
    var state = (0, state_1.useStateValue)().state;
    var products = state.products;
    var generateIngredientSection = function (products) {
        var ingredientSection = products.map(function (product, index) {
            return React.createElement("div", { className: "compare-product-content".concat(index === 0 ? '-first' : ''), key: product.arident },
                React.createElement("section", { className: "ingredients" },
                    React.createElement("h2", { className: "top hidden-xs" }, "Ingredienser"),
                    React.createElement("p", { className: "ingredient-text" }, !product.ingredients ? "Ikke oppgitt" :
                        React.createElement("span", { dangerouslySetInnerHTML: { __html: product.ingredients } }))));
        });
        return ingredientSection;
    };
    return (React.createElement("div", { className: "row ingredient-section" },
        React.createElement("h2", { className: "top visible-xs" }, "Ingredienser"),
        React.createElement("div", { className: "ingredient-container" }, generateIngredientSection(products))));
};
exports.Ingredients = Ingredients;
